module.exports = __webpack_public_path__ + "img/bannerOrange.f7654117.jpg";